I18n.translations || (I18n.translations = {});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Возникли ошибки: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Невозможно удалить запись, так как существуют зависимости: %{record}",
          "has_one": "Невозможно удалить запись, так как существует зависимость: %{record}"
        }
      }
    }
  },
  "add_bank_account": {
    "perform_authorization": "Выполнить банковскую аутентификацию"
  },
  "app": {
    "navigation": {
      "contact_title": "Finlo - Контакты",
      "home_title": "Finlo - Главная",
      "loan_types_title": "Finlo - Типы займов"
    },
    "pages": {
      "contact": "Контакты",
      "home": "Главная",
      "loan_types": "Типы займов",
      "services": "Услуги"
    }
  },
  "common": {
    "apply": "ПОДАТЬ ЗАЯВКУ",
    "back": "Назад",
    "cancel": "Отмена",
    "close": "Закрыть",
    "confirm": "Подтвердить",
    "contact_us": "Свяжитесь с нами",
    "delete": "Удалить",
    "edit": "Редактировать",
    "error": "Ошибка",
    "learn_more": "Узнать больше",
    "loading": "Загрузка...",
    "next": "Далее",
    "required": "*",
    "save": "Сохранить",
    "submit": "Отправить",
    "success": "Успешно"
  },
  "contact": {
    "address_full": "ул. Букулту 11, Рига, LV-1005",
    "address_hours": "Рабочие дни: 9:00 - 18:00",
    "address_label": "Адрес",
    "contact_info_title": "Контактная информация",
    "email_address": "info@finlo.lv",
    "email_label": "Email",
    "email_response": "Ответим в течение 24ч",
    "error_message": "Извините, произошла ошибка при отправке сообщения. Пожалуйста, попробуйте снова или позвоните нам.",
    "form": {
      "agree_marketing": "Я хочу получать информацию о последних предложениях и новостях",
      "agree_terms_prefix": "Я согласен с",
      "and": "и",
      "description": "Заполните форму, и мы свяжемся с вами как можно скорее.",
      "email": "Email адрес",
      "first_name": "Имя",
      "last_name": "Фамилия",
      "message": "Сообщение",
      "phone": "Номер телефона",
      "privacy_policy_link": "политикой конфиденциальности",
      "subject": "Тема",
      "submit_button": "Отправить сообщение",
      "submitting": "Отправка...",
      "terms_link": "условиями использования",
      "title": "Отправить сообщение"
    },
    "page_description": "Для нас важно услышать ваше мнение и ответить на ваши вопросы. Свяжитесь с нами, и мы ответим в течение 24 часов.",
    "page_title": "Свяжитесь с <span class='text-primary-500'>нами</span>",
    "phone_hours": "Рабочие дни: 9:00 - 18:00",
    "phone_label": "Телефон",
    "phone_number": "67199606",
    "subjects": {
      "complaint": "Жалоба",
      "existing": "Вопросы по существующему займу",
      "general": "Общие вопросы",
      "loan": "Заявка на займ",
      "other": "Другое"
    },
    "success_message": "Спасибо за ваше сообщение! Мы свяжемся с вами в течение 24 часов.",
    "validation": {
      "email_invalid": "Неверный формат email",
      "email_required": "Email обязателен",
      "first_name_required": "Имя обязательно",
      "last_name_required": "Фамилия обязательна",
      "message_required": "Сообщение обязательно",
      "phone_required": "Номер телефона обязателен",
      "subject_required": "Тема обязательна",
      "terms_required": "Вы должны согласиться с политикой конфиденциальности и условиями использования"
    }
  },
  "cookie_consent": {
    "accept": "Принять",
    "decline": "Отклонить",
    "message": "Мы используем файлы cookie для улучшения вашего опыта на нашем сайте. Продолжая использовать сайт, вы соглашаетесь с нашей",
    "privacy_policy_link": "политикой конфиденциальности"
  },
  "currency": {
    "eur": "EUR",
    "symbol": "€"
  },
  "date": {
    "abbr_day_names": [
      "Вс",
      "Пн",
      "Вт",
      "Ср",
      "Чт",
      "Пт",
      "Сб"
    ],
    "abbr_month_names": [
      null,
      "янв.",
      "февр.",
      "марта",
      "апр.",
      "мая",
      "июня",
      "июля",
      "авг.",
      "сент.",
      "окт.",
      "нояб.",
      "дек."
    ],
    "day_names": [
      "воскресенье",
      "понедельник",
      "вторник",
      "среда",
      "четверг",
      "пятница",
      "суббота"
    ],
    "formats": {
      "default": "%d.%m.%Y",
      "long": "%-d %B %Y",
      "short": "%-d %b"
    },
    "month_names": [
      null,
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "few": "около %{count} часов",
        "many": "около %{count} часов",
        "one": "около %{count} часа",
        "other": "около %{count} часов"
      },
      "about_x_months": {
        "few": "около %{count} месяцев",
        "many": "около %{count} месяцев",
        "one": "около %{count} месяца",
        "other": "около %{count} месяцев"
      },
      "about_x_years": {
        "few": "около %{count} лет",
        "many": "около %{count} лет",
        "one": "около %{count} года",
        "other": "около %{count} лет"
      },
      "almost_x_years": {
        "few": "почти %{count} года",
        "many": "почти %{count} лет",
        "one": "почти %{count} год",
        "other": "почти %{count} лет"
      },
      "half_a_minute": "полминуты",
      "less_than_x_minutes": {
        "few": "меньше %{count} минут",
        "many": "меньше %{count} минут",
        "one": "меньше %{count} минуты",
        "other": "меньше %{count} минут"
      },
      "less_than_x_seconds": {
        "few": "меньше %{count} секунд",
        "many": "меньше %{count} секунд",
        "one": "меньше %{count} секунды",
        "other": "меньше %{count} секунд"
      },
      "over_x_years": {
        "few": "больше %{count} лет",
        "many": "больше %{count} лет",
        "one": "больше %{count} года",
        "other": "больше %{count} лет"
      },
      "x_days": {
        "few": "%{count} дня",
        "many": "%{count} дней",
        "one": "%{count} день",
        "other": "%{count} дней"
      },
      "x_minutes": {
        "few": "%{count} минуты",
        "many": "%{count} минут",
        "one": "%{count} минута",
        "other": "%{count} минут"
      },
      "x_months": {
        "few": "%{count} месяца",
        "many": "%{count} месяцев",
        "one": "%{count} месяц",
        "other": "%{count} месяцев"
      },
      "x_seconds": {
        "few": "%{count} секунды",
        "many": "%{count} секунд",
        "one": "%{count} секунда",
        "other": "%{count} секунд"
      },
      "x_years": {
        "few": "%{count} года",
        "many": "%{count} лет",
        "one": "%{count} год",
        "other": "%{count} лет"
      }
    },
    "prompts": {
      "day": "День",
      "hour": "Час",
      "minute": "Минута",
      "month": "Месяц",
      "second": "Секунда",
      "year": "Год"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "нужно подтвердить",
      "blank": "не может быть пустым",
      "confirmation": "не совпадает со значением поля %{attribute}",
      "empty": "не может быть пустым",
      "equal_to": "может иметь лишь значение, равное %{count}",
      "even": "может иметь лишь четное значение",
      "exclusion": "имеет зарезервированное значение",
      "greater_than": "может иметь значение большее %{count}",
      "greater_than_or_equal_to": "может иметь значение большее или равное %{count}",
      "in": "должно быть в диапазоне %{count}",
      "inclusion": "имеет непредусмотренное значение",
      "invalid": "имеет неверное значение",
      "less_than": "может иметь значение меньшее чем %{count}",
      "less_than_or_equal_to": "может иметь значение меньшее или равное %{count}",
      "model_invalid": "Возникли ошибки: %{errors}",
      "not_a_number": "не является числом",
      "not_an_integer": "не является целым числом",
      "odd": "может иметь лишь нечетное значение",
      "other_than": "должно отличаться от %{count}",
      "present": "нужно оставить пустым",
      "required": "не может отсутствовать",
      "taken": "уже существует",
      "too_long": {
        "few": "слишком большой длины (не может быть больше чем %{count} символа)",
        "many": "слишком большой длины (не может быть больше чем %{count} символов)",
        "one": "слишком большой длины (не может быть больше чем %{count} символ)",
        "other": "слишком большой длины (не может быть больше чем %{count} символа)"
      },
      "too_short": {
        "few": "недостаточной длины (не может быть меньше %{count} символов)",
        "many": "недостаточной длины (не может быть меньше %{count} символов)",
        "one": "недостаточной длины (не может быть меньше %{count} символа)",
        "other": "недостаточной длины (не может быть меньше %{count} символа)"
      },
      "wrong_length": {
        "few": "неверной длины (может быть длиной ровно %{count} символа)",
        "many": "неверной длины (может быть длиной ровно %{count} символов)",
        "one": "неверной длины (может быть длиной ровно %{count} символ)",
        "other": "неверной длины (может быть длиной ровно %{count} символа)"
      }
    },
    "template": {
      "body": "Проблемы возникли со следующими полями:",
      "header": {
        "few": "%{model}: сохранение не удалось из-за %{count} ошибок",
        "many": "%{model}: сохранение не удалось из-за %{count} ошибок",
        "one": "%{model}: сохранение не удалось из-за %{count} ошибки",
        "other": "%{model}: сохранение не удалось из-за %{count} ошибки"
      }
    }
  },
  "footer": {
    "about_us": "О нас",
    "contacts": "Контакты",
    "faq": "FAQ",
    "license": "Лицензия №2016-026",
    "logo_alt": "Finlo",
    "other_title": "Другое",
    "privacy_policy": "Политика конфиденциальности",
    "services": {
      "business_loan": "Развитие бизнеса",
      "construction_loan": "Строительство",
      "farm_loan": "Для фермеров",
      "loan_consolidation": "Объединение кредитов",
      "mortgage_loan": "Ипотечный кредит"
    },
    "services_title": "Услуги",
    "social_networks": "Социальные сети",
    "terms_of_use": "Условия использования"
  },
  "header": {
    "address": "ул. Букулту 11, Рига, LV-1005",
    "contact": "Контакты",
    "contacts": "Контакты",
    "faq": "FAQ",
    "home": "Главная",
    "how_to_apply": "Как подать заявку?",
    "logo_alt": "Finlo",
    "phone": "67199606",
    "services": "Услуги",
    "why_us": "Почему мы?",
    "working_hours": "Понедельник-Пятница: 08-17"
  },
  "helpers": {
    "select": {
      "prompt": "Выберите: "
    },
    "submit": {
      "create": "Создать %{model}",
      "submit": "Сохранить %{model}",
      "update": "Сохранить %{model}"
    }
  },
  "home": {
    "about_us_title": "О нас",
    "contact_page": {
      "company_address": "Bukultu iela 11, Rīga, LV-1005",
      "company_details": "Реквизиты",
      "company_name": "SIA \"Digital Investment MGMT\"",
      "company_registration": "Регистрационный номер: 40103162565",
      "faq_description": "Ответы на часто задаваемые вопросы о наших услугах",
      "faq_section": "ЧАВО",
      "how_to_get_there": "Как добраться?",
      "license": "Лицензия №2016-026",
      "privacy_policy": "Политика конфиденциальности",
      "social_networks": "Социальные сети",
      "terms_of_use": "Условия использования",
      "working_hours": "Рабочие часы",
      "working_hours_weekdays": "Пн-Пт. 8:00-17:00",
      "working_hours_weekend": "Сб., Вс.- закрыто"
    },
    "contact_phone": "67199606",
    "contact_us_title": "Свяжитесь с нами",
    "faq": [
      {
        "title": "Возможно ли погасить кредит досрочно?",
        "content": "Да, кредит можно погасить досрочно."
      },
      {
        "title": "Возможно ли получить часть кредита немедленно?",
        "content": "Для решения срочных бизнес-вопросов мы можем рассмотреть выдачу части финансирования в день подписания договора."
      },
      {
        "title": "Если я беру займ для объединения кредитов, кто будет погашать кредиты?",
        "content": "FINLO переведет займ на ваш расчетный банковский счет, поэтому вы будете ответственны за погашение кредитов и подачу платежных поручений для подтверждения погашения в FINLO."
      },
      {
        "title": "Будет ли проведена оценка недвижимости?",
        "content": "Да, мы заказываем оценку недвижимости у сертифицированного оценщика."
      }
    ],
    "faq_title": "Часто задаваемые вопросы",
    "features": {
      "all_latvia": "Кредитуем по всей Латвии",
      "licensed_lender": "Лицензированный кредитор",
      "real_estate_secured": "Кредиты под залог недвижимости",
      "since_2008": "На рынке с 2008 года"
    },
    "form_submitted_message": "Заявка отправлена!",
    "hero_title": "Современный подход<br/>к выдаче займов",
    "loan_types_page": {
      "application_submitted": "Ваша заявка отправлена! Мы свяжемся с вами в ближайшее время.",
      "apply_for_loan": "Подать заявку на",
      "apply_now": "Подать заявку сейчас",
      "competitive_rates": "Конкурентные ставки",
      "competitive_rates_description": "Мы предлагаем одни из самых низких процентных ставок на рынке от 9% + EURIBOR.",
      "fast_approval": "Быстрое одобрение",
      "fast_approval_description": "Мы оцениваем заявки в течение одного рабочего дня и даем быстрые ответы.",
      "fill_application": "Заполните заявку и получите предложение",
      "flexible_terms": "Гибкие условия",
      "hero_description": "Выберите наиболее подходящий тип кредита для ваших потребностей. Мы предлагаем широкий спектр услуг для различных целей.",
      "hero_title": "Наши Услуги",
      "main_advantages": "Основные преимущества",
      "personal_approach": "Персональный подход",
      "personal_approach_description": "Мы предлагаем каждому клиенту индивидуальное решение, которое соответствует вашим потребностям.",
      "required_documents": "Необходимые документы",
      "trusted_partner": "Мы ваш надежный партнер в области кредитования с более чем 10-летним опытом",
      "why_choose_finlo": "Почему выбрать Finlo?"
    },
    "qualities": [
      "Предложение в течение дня",
      "Индивидуальный график погашения",
      "Динамическое обслуживание",
      "Индивидуальный подход",
      "Удаленное оформление",
      "Минимальная бюрократия"
    ],
    "service_description": "Направление деятельности Finlo - выдача займов под залог недвижимости или ипотечных кредитов. Понимая пожелания и потребности клиентов, мы разработали процедуру подачи заявки и оценки кредита максимально удобной и подходящей для клиента.",
    "service_image_alt": "Изображение услуг Finlo",
    "service_title": "Персональный подход и профессиональное обслуживание",
    "services_title": "Наш спектр услуг",
    "slides": {
      "auto_leasing": {
        "description": "Полносервисный автолизинг со всеми дополнительными услугами - от выбора транспортного средства до организации обслуживания.",
        "title": "Автолизинг"
      },
      "business_development": {
        "description": "Капитал для реализации новых проектов, роста компании и повышения конкурентоспособности.",
        "title": "Развитие бизнеса"
      },
      "construction": {
        "description": "Финансирование строительства новых зданий или реконструкции существующих, обеспечивая качественное и современное строительство.",
        "title": "Строительство"
      },
      "credit_consolidation": {
        "description": "Объедините несколько кредитов в один, снизив ежемесячные платежи и упростив финансовое планирование.",
        "title": "Объединение кредитов"
      },
      "farmers": {
        "description": "Финансирование ремонта и обслуживания сельскохозяйственной техники, обеспечивающее непрерывную работу хозяйства.",
        "title": "Для фермеров"
      },
      "mortgage_loan": {
        "description": "Займы под залог недвижимости для любых целей - покупки жилья, ремонта или других потребностей.",
        "title": "Ипотечный кредит"
      }
    },
    "why_us_title": "Почему выбирают нас?"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "few",
        "many",
        "other"
      ]
    },
    "transliterate": {}
  },
  "language_switcher": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский"
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский"
  },
  "loan_form": {
    "buttons": {
      "back_full": "← Назад",
      "back_short": "← Назад",
      "close_full": "Закрыть",
      "limit_exceeded": "Превышен лимит заявок",
      "next_full": "Далее →",
      "next_short": "Далее →",
      "submit_full": "✓ Отправить заявку",
      "submit_short": "✓ Отправить"
    },
    "family_status": {
      "married": "Женат/замужем",
      "single": "Холост/не замужем"
    },
    "fields": {
      "addresses_match": "Фактический адрес совпадает с декларированным",
      "agree_terms": "Я согласен с <a href='/documents/ru/terms.pdf' target='_blank' rel='noopener noreferrer' class='text-primary-500 hover:text-primary-600 font-medium underline'>условиями использования</a> и <a href='/documents/ru/privacy_policy.pdf' target='_blank' rel='noopener noreferrer' class='text-primary-500 hover:text-primary-600 font-medium underline'>политикой конфиденциальности</a>",
      "bank_account": "Банковский счет",
      "bank_authorization": "Я разрешаю доступ к моим банковским данным для автоматической верификации",
      "city": "Город",
      "declared_address": "Улица / название дома",
      "dependent_persons": "Количество иждивенцев",
      "documents": "Загрузите необходимые документы",
      "email": "Email",
      "factual_address": "Улица / название дома",
      "family_status": "Семейный статус",
      "first_name": "Имя",
      "has_real_estate": "Есть ли у вас недвижимость?",
      "is_politically_important": "Являетесь ли вы политически значимым лицом?",
      "is_politically_important_tooltip": "Политически значимое лицо — это физическое лицо, которое занимает или занимало важную публичную должность, например, глава государства или правительства, министр, член парламента и т.д.",
      "job_type": "Тип работы",
      "last_name": "Фамилия",
      "loan_amount": "Сумма займа",
      "loan_period": "Период займа",
      "loan_type": "Тип займа",
      "monthly_income": "Ежемесячный доход, EUR",
      "monthly_payments": "Ежемесячные кредитные платежи, EUR",
      "personal_code": "Персональный код",
      "phone": "Телефон",
      "select_bank": "Выберите банк"
    },
    "file_upload": {
      "error": "Ошибка загрузки файла",
      "max": "Достигнуто максимальное количество файлов",
      "removed": "Файл удален",
      "size": "Файл слишком большой",
      "success": "Файл успешно загружен",
      "type": "Неверный тип файла"
    },
    "job_types": {
      "other": "Другое",
      "permanent": "Постоянная работа",
      "retired": "Пенсионер",
      "self_employed": "Самозанятый",
      "student": "Студент",
      "temporary": "Временная работа",
      "unemployed": "Безработный"
    },
    "limit_exceeded": "Вы превысили возможное количество заявок.",
    "loan_types": {
      "business": "Бизнес кредит",
      "carLeasing": "Автолизинг",
      "consumer": "Потребительский кредит",
      "credit_consolidation": "Консолидация кредитов",
      "mortgage": "Ипотечный займ"
    },
    "messages": {
      "error": "Произошла ошибка. Пожалуйста, попробуйте снова или свяжитесь с нами.",
      "success": "Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время."
    },
    "no": "Нет",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Рига",
      "declared_address": "ул. Свободы 123, Рига",
      "monthly_income": "0",
      "monthly_payments": "0",
      "personal_code": "123456-12345",
      "phone": "22222222",
      "select_bank": "Выберите банк",
      "select_count": "Выберите количество",
      "select_job_type": "Выберите тип работы",
      "select_loan_type": "Выберите тип займа",
      "select_status": "Выберите статус"
    },
    "processing": "Обработка...",
    "remaining_applications": "Оставшиеся заявки:",
    "step_descriptions": {
      "address_info": "Укажите информацию о месте жительства",
      "bank_verification": "Выберите способ банковской верификации",
      "family_info": "Информация о семейном статусе и трудоустройстве",
      "loan_details": "Выберите тип займа и сумму",
      "personal_info": "Пожалуйста, введите вашу личную информацию"
    },
    "step_labels": {
      "address_full": "Адресная информация",
      "address_short": "Адрес",
      "bank_full": "Банковская верификация",
      "bank_short": "Банк",
      "family_full": "Семейная информация",
      "family_short": "Семья",
      "loan_full": "Детали займа",
      "loan_short": "Займ",
      "personal_full": "Личная информация",
      "personal_short": "Личная"
    },
    "step_titles": {
      "address_info": "Адресная информация",
      "bank_verification": "Банковская верификация",
      "family_info": "Семейная информация",
      "loan_details": "Детали займа",
      "personal_info": "Личная информация"
    },
    "title": "Заявка на займ",
    "try_again_in": "Пожалуйста, попробуйте снова через",
    "units": {
      "euro": "€",
      "months": "месяцы"
    },
    "yes": "Да"
  },
  "loan_type_page": {
    "benefits_description": "Наш займ предлагает несколько значительных преимуществ для вашей финансовой стабильности",
    "benefits_title": "Преимущества",
    "contact_description": "Свяжитесь с нашими экспертами и получите персональную консультацию",
    "contact_title": "У вас есть вопросы?",
    "faq_title": "Часто задаваемые вопросы",
    "how_to_apply_title": "Как подать заявку?",
    "interest_rate": "Годовая процентная ставка:",
    "key_conditions": "Основные условия",
    "period": "Период:",
    "phone_number": "67199606",
    "security": "Обеспечение:",
    "success_message": "Ваша заявка отправлена! Мы свяжемся с вами в ближайшее время."
  },
  "loan_types": {
    "auto": {
      "description": "Удобная и быстрая покупка автомобиля с нашими предложениями лизинга",
      "features": [
        "Процентная ставка от 7% + EURIBOR",
        "Стоимость автомобиля до 100 000 EUR",
        "Срок погашения до 7 лет",
        "Новые и подержанные автомобили",
        "Быстрое одобрение",
        "Без первоначального взноса"
      ],
      "requirements": [
        "Выбор автомобиля и цена",
        "Документы, подтверждающие доходы",
        "Документ, удостоверяющий личность",
        "Страхование автомобиля"
      ],
      "title": "Автолизинг"
    },
    "business": {
      "description": "Финансирование роста бизнеса и реализации новых проектов",
      "features": [
        "Процентная ставка от 12% + EURIBOR",
        "Сумма кредита до 500 000 EUR",
        "Срок погашения до 25 лет",
        "Индивидуальное решение для каждого бизнеса",
        "Гибкие условия платежей",
        "Персонализированное обслуживание клиентов"
      ],
      "requirements": [
        "Информация о недвижимости",
        "Баланс компании",
        "Выписка по счету за последние 6 месяцев или банковская авторизация на последнем шаге заявки"
      ],
      "title": "Развитие бизнеса"
    },
    "consolidation": {
      "description": "Объедините существующие кредиты в один с лучшими условиями",
      "features": [
        "Более низкая общая процентная ставка",
        "Один ежемесячный платеж",
        "Продленный срок погашения",
        "Сниженный ежемесячный платеж",
        "Упрощенное администрирование",
        "Без скрытых комиссий"
      ],
      "requirements": [
        "Необходимые документы",
        "Банковская верификация на последнем шаге заявки"
      ],
      "title": "Объединение кредитов"
    },
    "construction": {
      "description": "Специализированное финансирование строительных проектов и реновации",
      "features": [
        "Процентная ставка от 7% + EURIBOR",
        "Сумма кредита до 1 000 000 EUR",
        "Срок погашения до 35 лет",
        "Поэтапное финансирование",
        "Надзор за строительством",
        "Профессиональные консультации"
      ],
      "requirements": [
        "Информация о недвижимости",
        "Смета на строительство"
      ],
      "title": "Строительство"
    },
    "farm": {
      "description": "Специализированное финансирование сельскохозяйственных нужд",
      "features": [
        "Сезонные платежи",
        "Индивидуально адаптированные условия",
        "Финансирование техники и оборудования",
        "Кредиты на оборотные средства",
        "Финансирование покупки земли",
        "Кредиты софинансирования фондов ЕС"
      ],
      "requirements": [
        "Документы регистрации хозяйства",
        "Справка о правах землепользования",
        "План производства",
        "Финансовые документы"
      ],
      "title": "Для фермеров"
    },
    "features_list": {
      "fast_processing": "Быстрая обработка",
      "fast_processing_desc": "Решение по займу принимается в течение 24 часов после получения всех документов.",
      "flexible_terms": "Гибкие условия",
      "flexible_terms_desc": "Мы адаптируем условия займа индивидуально для каждого клиента, учитывая специфические потребности.",
      "personal_approach": "Персональный подход",
      "personal_approach_desc": "Каждому клиенту мы предлагаем индивидуальное решение, которое соответствует вашим потребностям."
    },
    "features_title": "Наши преимущества",
    "mortgage": {
      "description": "Займы под залог недвижимости для любых целей",
      "features": [
        "Процентная ставка от 9% + EURIBOR",
        "Сумма кредита до 300 000 EUR",
        "Срок погашения до 30 лет",
        "Быстрая оценка - 1 рабочий день",
        "Гибкие графики платежей",
        "Без дополнительных комиссий"
      ],
      "requirements": [
        "Залог недвижимости",
        "Документы, подтверждающие доходы",
        "Отчет об оценке недвижимости",
        "Документ, удостоверяющий личность"
      ],
      "title": "Ипотечный кредит"
    },
    "page_description": "Выберите наиболее подходящий тип займа для ваших потребностей. Мы предлагаем широкий спектр услуг для различных целей.",
    "page_title": "Наши <span class='text-primary-500'>Услуги</span>",
    "pages": {
      "auto": {
        "apply_button": "Подать заявку на автолизинг",
        "hero_subtitle": "Удобная и быстрая покупка автомобиля с нашими лизинговыми предложениями",
        "hero_title": "Автолизинг",
        "meta_description": "Автолизинг для покупки новых и подержанных автомобилей. Сумма кредита до 100 000 EUR, без первоначального взноса.",
        "meta_title": "Автолизинг - Finlo",
        "title": "Автолизинг"
      },
      "business": {
        "apply_button": "Подать заявку на бизнес кредит",
        "hero_subtitle": "Финансирование роста бизнеса и реализации новых проектов",
        "hero_title": "Развитие бизнеса",
        "meta_description": "Бизнес кредит для развития компаний. Сумма кредита до 500 000 EUR, гибкие условия.",
        "meta_title": "Бизнес кредит - Finlo",
        "title": "Развитие бизнеса"
      },
      "consolidation": {
        "apply_button": "Подать заявку на объединение кредитов",
        "hero_subtitle": "Объедините существующие кредиты в один с лучшими условиями",
        "hero_title": "Объединение кредитов",
        "meta_description": "Объедините существующие кредиты в один с лучшими условиями. Снизьте ежемесячный платеж.",
        "meta_title": "Объединение кредитов - Finlo",
        "title": "Объединение кредитов"
      },
      "construction": {
        "apply_button": "Подать заявку на строительный кредит",
        "hero_subtitle": "Специализированное финансирование строительных проектов и реновации",
        "hero_title": "Строительство",
        "meta_description": "Строительный кредит для новых зданий. Сумма кредита до 1 000 000 EUR, поэтапное финансирование.",
        "meta_title": "Строительный кредит - Finlo",
        "title": "Строительство"
      },
      "farmers": {
        "apply_button": "Подать заявку на сельскохозяйственный кредит",
        "hero_subtitle": "Специализированное финансирование сельскохозяйственных нужд",
        "hero_title": "Для фермеров",
        "meta_description": "Специализированное финансирование сельскохозяйственных нужд. Сезонные платежи, индивидуальные условия.",
        "meta_title": "Сельскохозяйственный кредит - Finlo",
        "title": "Для фермеров"
      },
      "mortgage": {
        "apply_button": "Подать заявку на ипотеку",
        "hero_subtitle": "Займы под залог недвижимости для любых целей",
        "hero_title": "Ипотечный кредит",
        "meta_description": "Ипотечный кредит с лучшими процентными ставками. Сумма кредита до 300 000 EUR, срок погашения до 30 лет.",
        "meta_title": "Ипотечный кредит - Finlo",
        "title": "Ипотечный кредит"
      }
    },
    "tab_labels": {
      "business": "Бизнес",
      "consolidation": "Объединение",
      "construction": "Строительство",
      "farm": "Фермеры",
      "mortgage": "Ипотека"
    }
  },
  "loan_types_component": {
    "apply_button": "Подать заявку сейчас",
    "form_description": "Заполните заявку и получите предложение в течение нескольких минут",
    "form_description_desktop": "Заполните заявку и получите предложение",
    "form_title": "Подать заявку на займ",
    "image_alt": "Счастливая финансовая женщина",
    "success_message": "Ваша заявка отправлена! Мы свяжемся с вами в ближайшее время.",
    "title": "Наши типы займов"
  },
  "meta": {
    "keywords": "займ, кредит, ипотека, бизнес кредит, finlo",
    "og_description": "Направление деятельности Finlo - выдача займов под залог недвижимости или ипотечных кредитов. Понимая пожелания и потребности клиентов, мы разработали процедуру подачи заявки и оценки кредита максимально удобной и подходящей для клиента.",
    "og_image": "https://www.finlo.lv/og-image.jpg",
    "og_locale": "ru_RU",
    "og_title": "Finlo - Современный подход к выдаче займов",
    "og_type": "website",
    "og_url": "https://www.finlo.lv",
    "site_description": "Современный подход к выдаче займов. Лицензированный кредитор с займами под залог недвижимости.",
    "site_name": "Finlo",
    "twitter_card": "summary_large_image",
    "twitter_description": "Лицензированный кредитор с займами под залог недвижимости. Кредитуем по всей Латвии с 2008 года.",
    "twitter_image": "https://www.finlo.lv/twitter-image.jpg",
    "twitter_site": "@finlo_lv",
    "twitter_title": "Finlo - Современный подход к выдаче займов"
  },
  "months": {
    "april": "Апрель",
    "august": "Август",
    "december": "Декабрь",
    "february": "Февраль",
    "january": "Январь",
    "july": "Июль",
    "june": "Июнь",
    "march": "Март",
    "may": "Май",
    "november": "Ноябрь",
    "october": "Октябрь",
    "september": "Сентябрь"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "руб."
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "few": "миллиардов",
            "many": "миллиардов",
            "one": "миллиард",
            "other": "миллиардов"
          },
          "million": {
            "few": "миллионов",
            "many": "миллионов",
            "one": "миллион",
            "other": "миллионов"
          },
          "quadrillion": {
            "few": "квадриллионов",
            "many": "квадриллионов",
            "one": "квадриллион",
            "other": "квадриллионов"
          },
          "thousand": {
            "few": "тысяч",
            "many": "тысяч",
            "one": "тысяча",
            "other": "тысяч"
          },
          "trillion": {
            "few": "триллионов",
            "many": "триллионов",
            "one": "триллион",
            "other": "триллионов"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "few": "байта",
            "many": "байт",
            "one": "байт",
            "other": "байта"
          },
          "eb": "ЭБ",
          "gb": "ГБ",
          "kb": "КБ",
          "mb": "МБ",
          "pb": "ПБ",
          "tb": "ТБ"
        }
      }
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "periods": {
    "month": "месяц",
    "months": "месяцы",
    "year": "год",
    "years": "годы"
  },
  "phone": {
    "country_codes": {
      "de": "DE +49",
      "dk": "DK +45",
      "ee": "EE +372",
      "false": "NO +47",
      "fi": "FI +358",
      "gb": "GB +44",
      "lt": "LT +370",
      "lv": "LV +371",
      "se": "SE +46",
      "us": "US +1"
    }
  },
  "services": {
    "auto_leasing": "Автолизинг",
    "business_development": "Для развития бизнеса",
    "construction": "Строительство",
    "farmers": "Для фермеров",
    "loan_consolidation": "Объединение кредитов",
    "mortgage_loan": "Ипотечный кредит"
  },
  "support": {
    "array": {
      "last_word_connector": " и ",
      "two_words_connector": " и ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "утра",
    "formats": {
      "default": "%a, %d %b %Y, %H:%M:%S %z",
      "long": "%d %B %Y, %H:%M",
      "short": "%d %b, %H:%M"
    },
    "pm": "вечера"
  }
});
